<dgx-modal
  bodyClasses="guts-p-full-0"
  [canCancel]="true"
  [useDefaultForm]="false"
  [isFooterless]="true"
  [isHeaderBorderless]="!addResourcesModel.hideFeatures"
  (dismiss)="dismiss()"
>
  <ng-container class="modal-header">
    {{ 'TargetResources_AddResources' | translate }}
  </ng-container>

  <ng-container class="modal-body">
    <dgx-tab-navigation-routerless
      *ngIf="tabList.length > 1; else addBySearch"
      [tabList]="tabList"
      defaultActiveTabId="addBySearch"
      wrapperClasses="guts-p-h-2"
    >
    </dgx-tab-navigation-routerless>
  </ng-container>
</dgx-modal>

<ng-template #addBySearch>
  <form>
    <dgx-add-by-search-mixed
      *ngIf="!addResourcesModel.hideFeatures; else basicSearch"
      [isSubmitting]="isSubmitting"
      [savedSearch]="searchItems"
      [showHoldForLater]="false"
      [resourceOrgId]="addResourcesModel.target?.organizationId"
      [resourceId]="addResourcesModel.target?.targetId"
      [closeSearchOnSelect]="false"
      [exclusionList]="addResourcesModel.exclusionList"
      (addItems)="itemsAdded($event)"
      (updateItemList)="updateSearchItems($event)"
      (dismiss)="dismiss()"
      resourceType="Target"
    ></dgx-add-by-search-mixed>
    <ng-template #basicSearch>
      <dgx-add-by-search
        [savedSearch]="searchItems"
        [isSubmitting]="isSubmitting"
        [showHoldForLater]="false"
        (addItems)="itemsAdded($event)"
        (updateItemList)="updateSearchItems($event)"
        resourceType="Target"
        [resourceOrgId]="addResourcesModel.target?.organizationId"
        (dismiss)="dismiss()"
      ></dgx-add-by-search>
    </ng-template>
  </form>
</ng-template>
<ng-template #addByType>
  <form>
    <dgx-target-add-by-type
      [savedSearch]="searchItems"
      [isSubmitting]="isSubmitting"
      [target]="addResourcesModel.target"
      (addItems)="itemsAdded($event)"
      (updateItemList)="updateSearchItems($event)"
      (dismiss)="dismiss()"
    ></dgx-target-add-by-type>
  </form>
</ng-template>
